
import React, { Fragment, useState } from 'react'

import './CncList.scss'
import { Card } from 'react-bootstrap'
import useTranslation from '@/Hooks/UseTranslation'
import CncSelector from '@/Components/CncSelector/CncSelector'

import Toast from "@/Components/Toast/Toast";
import { useDispatch } from 'react-redux'
import { assignCNCAction } from '@/Redux/Actions/ResourcesCNCActions'
import Icon from "@/Components/Icon/Icon";
import UserAvatar from '@/Components/UserAvatar/UserAvatar'

interface Props {
  list: any[]
  assigningList: any[]
  loadStatus: string
  onUpdateList: () => Promise<void>
}

const CncList = (props: Props) => {

  const { list, assigningList, loadStatus, onUpdateList } = props

  const { t } = useTranslation()

  const dispatch = useDispatch()

  const [cncSelector, setCNCSelector] = useState({
    show: false,
    twp: {
      _id: ''
    },
    twp_index: -1,
  })

  const setTaskWeeklyProgress = (twp: any, twp_index: number) => {

    setCNCSelector({
      show: true,
      twp,
      twp_index,
    })
  }

  const handleAssignCNC = async (cnc: any) => {

    const assigned = await dispatch(assignCNCAction(cncSelector.twp._id, cnc._id))

    if (!assigned) {

      Toast.show(t('RESOURCES_CNC:AssignAlertTitle'), (
        <>
          {t('RESOURCES_CNC:AssignAlertContent')}
          <button className='btn btn-primary'
            onClick={() => handleAssignCNC(cnc)}
          >
            <Icon name="sync" fas fw /> {' '}
            {t('RESOURCES_CNC:AssignAlertRetryButton')}
          </button>
        </>
      ), {
        type: 'default',
        position: 'bottom-right',
        autoClose: false,
        closeOnClick: false,
        closeButton: false,
        draggable: false,
      });
      return
    }

    Toast.close()
  }

  return (
    <Fragment>
      <Card className="table-card cnc-list">
        <div>
          <div className="table-responsive">
            <table className="table card-table pl4-cnc-assignments-table">
              <thead>
                <tr>
                  <th className="text-center d-none" style={{ width: '5%' }}>#</th>
                  <th>
                    {t('RESOURCES_CNC:NotCompletedTaskColumn')}
                  </th>
                  <th className="text-center" style={{ width: '30%' }}>
                    {t('RESOURCES_CNC:NotCompletedCNCColumn')}
                  </th>
                  <th className="text-center" style={{ width: '15%' }}>
                    {t('RESOURCES_CNC:NotCompletedTypeColumn')}
                  </th>
                  <th className="text-center" style={{ width: '15%' }}>
                    {t('RESOURCES_CNC:NotCompletedResponsibleColumn')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {list.map((taskWeeklyProgress: any, i: number) => (
                  <tr key={i}>
                    <td className="text-center d-none"></td>
                    <td>{taskWeeklyProgress.task.name}</td>
                    <td className="text-center">
                      {taskWeeklyProgress.cnc && taskWeeklyProgress.cnc.name}
                      {!taskWeeklyProgress.cnc && (
                        <>
                          {assigningList.includes(taskWeeklyProgress._id) ? (
                            <>
                              <div className="spinner spinner-primary" style={{ width: 16, height: 16 }}></div> {' '}
                              {t('RESOURCES_CNC:NotCompletedAssigning')}
                            </>
                          ) : (
                            <>
                              <button className="btn btn-link pl4-btn pl4-btn-secondary pl4-btn-sm"
                                onClick={() => setTaskWeeklyProgress(taskWeeklyProgress, i)}
                              >
                                <Icon name="list-alt" far fw /> {' '}
                                {t('RESOURCES_CNC:NotCompletedSelectButton')}
                              </button>
                            </>
                          )}
                        </>
                      )}
                    </td>
                    <td className="text-center">
                      {taskWeeklyProgress.cnc && (
                        <>
                          {taskWeeklyProgress.cnc.type === "obra_construccion" && t('RESOURCES_CNC:ProjectConstructionCNCType')}
                          {taskWeeklyProgress.cnc.type === "diseno_oficina_tecnica_de_obra" && t('RESOURCES_CNC:DesignOTOCNCType')}
                          {taskWeeklyProgress.cnc.type === "administracion" && t('RESOURCES_CNC:AdministrationCNCType')}
                          {taskWeeklyProgress.cnc.type === "logistica" && t('RESOURCES_CNC:LogisticsCNCType')}
                          {taskWeeklyProgress.cnc.type === "condiciones_externas" && t('RESOURCES_CNC:ExternalConditionsCNCType')}
                        </>
                      )}
                    </td>
                    <td className="text-center">
                      {taskWeeklyProgress.task.responsibles.map((responsable: any, i: number) => (
                        <UserAvatar key={i} user={responsable} />
                      ))}
                    </td>
                  </tr>
                ))}
                {(loadStatus === 'none' || loadStatus === 'loading') && (
                  <tr>
                    <td colSpan={5} className="pl4-cnc-table-message">
                      {t('RESOURCES_CNC:LoadingNotCompleted')}
                    </td>
                  </tr>
                )}
                {loadStatus === 'error' && (
                  <tr>
                    <td colSpan={5} className="pl4-cnc-table-message">
                      <span>{t('RESOURCES_CNC:NotCompletedLoadError')}</span>{' '}
                      <button
                        type="button"
                        className="btn btn-link pl4-btn pl4-btn-secondary pl4-btn-sm"
                        onClick={onUpdateList}
                      >
                        <Icon name="sync" fas fw />{' '}
                        {t('RESOURCES_CNC:NotCompletedRetryButton')}
                      </button>
                    </td>
                  </tr>
                )}
                {loadStatus === 'loaded' && list.length === 0 && (
                  <tr>
                    <td colSpan={5} className="pl4-cnc-table-message">
                      {t('RESOURCES_CNC:NotCompletedEmpty')}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </Card>

      {cncSelector.show && (
        <CncSelector
          show={cncSelector.show}
          onHide={() => setCNCSelector({ ...cncSelector, show: false })}
          onSelect={(cnc: any) => handleAssignCNC(cnc)}
        />
      )}

    </Fragment>
  )
}

export default CncList
